export const ROUTER_PATHS = {
  root: '/',
  auth: {
    root: 'auth',
    login: 'login',
    forgotPassword: {
      root: 'forgot-password',
      init: 'init',
      finish: ':resetKey'
    }
  },
  dashboard: {
    root: 'dashboard'
  },
  customers: {
    root: 'customers',
    list: 'list'
  },
  projects: {
    root: 'project',
    list: 'list'
  },
  profile: {
    root: 'profile'
  },
  error: {
    notFound: 'not-found'
  },
  surveys: {
    root: 'surveys'
  }
};
